export const ROLES = {
  SEEKER: "SEEKER",
  MANUVATOR: "MANUVATOR",
  ADMIN: "ADMIN",
  EVALUATOR: "EVALUATOR",
};
